import { ReactComponent as FacebookIcon } from 'assets/icons/facebook.svg';
import { ReactComponent as LinkedInIcon } from 'assets/icons/linkedIn.svg';
import { ReactComponent as YoutubeIcon } from 'assets/icons/youtube.svg';

export const FOOTER_LINKS_CONFIG = [
  {
    name: 'common.label.termsOfUse',
    href: 'https://joblio.co/terms-of-use/'
  },
  {
    name: 'common.label.privacyPolicy',
    href: 'https://joblio.co/privacy-policy/'
  },
  {
    name: 'common.label.dataPrivacyRights',
    href: 'https://joblio.co/data-privacy-rights/'
  }
];

export const FOOTER_SOCIAL_CONFIG = [
  {
    icon: <FacebookIcon />,
    href: 'https://www.facebook.com/JoblioGlobal'
  },
  {
    icon: <LinkedInIcon />,
    href: 'https://www.linkedin.com/company/joblio'
  },
  {
    icon: <YoutubeIcon />,
    href: 'https://www.youtube.com/c/Joblioglobal'
  }
];
